export const EMPTY_DATA = 'ERROR_EMPTY_DATA';
export const RESPONSE = 'ERROR_RESPONSE';
export const RENDER = 'ERROR_RENDER';

const errors = { EMPTY_DATA, RESPONSE, RENDER };

export default errors;
